var map = {
	"./Art.webp": 35585,
	"./Beauty.webp": 42712,
	"./Dance.webp": 91455,
	"./Entertainment.webp": 73954,
	"./Food.webp": 30108,
	"./History.webp": 31408,
	"./Holiday & Party.webp": 65202,
	"./Kids.webp": 33897,
	"./Music.webp": 82635,
	"./Sport.webp": 94662,
	"./Technology.webp": 84686,
	"./Travel.webp": 46444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42408;